class StoreSwitcher extends HTMLElement {
  constructor() {
    super()

    this.els = {
      dialog: this.querySelector('[data-store-switcher-el="dialog"]'),
      closeButton: this.querySelector('[data-store-switcher-el="closeButton"]'),
      optionsList: this.querySelector('[data-store-switcher-el="optionsList"]'),
      button: this.querySelector('[data-store-switcher-el="submitButton"]'),
    }

    this.cookieName = 'YARDSALE-store-switcher-preference'
    this.cookieExpiration = 30 * 24 * 60 * 60 // 30 days in seconds
    this.sessionStorageKey = 'YARDSALE-store-switcher-dismissed'

    const dialog = this.els.dialog

    this.currentStoreRegion = dialog ? dialog.dataset.currentStoreRegion : null
    this.autoRedirect = dialog && dialog.dataset.autoRedirect === 'true'

    const euRegionCodes =
      dialog && dialog.dataset.euRegionCodes
        ? dialog.dataset.euRegionCodes
            .split(',')
            .map((code) => code.trim().toUpperCase())
            .filter((code) => code.length > 0)
        : []

    this.euRegionCodes = euRegionCodes

    const isHandled = this.checkCookie()
    if (!isHandled) {
      this.setupListeners()
    }
  }

  setupListeners() {
    this.getUserLocation()

    const buttonEl = this.els.button

    buttonEl.addEventListener('click', () => {
      this.redirectToStore()
    })

    const closeButtonEl = this.els.closeButton

    closeButtonEl.addEventListener('click', () => {
      sessionStorage.setItem(this.sessionStorageKey, 'true')
      this.hideDialog()
    })
  }

  getUserLocation() {
    if (sessionStorage.getItem(this.sessionStorageKey) === 'true') {
      return
    }

    fetch('https://ipapi.co/json/')
      .then((response) => response.json())
      .then((data) => {
        const detectedRegion = this.determineStoreRegion(data.country_code)
        this.detectedRegion = detectedRegion
        if (
          !this.cookieValue &&
          detectedRegion &&
          detectedRegion !== this.currentStoreRegion
        ) {
          if (this.autoRedirect) {
            this.autoRedirectToStore(detectedRegion)
          } else {
            this.showDialog()
          }
        }
      })
      .catch((error) => {
        console.log('Error getting IP location:', error)
      })
  }

  determineStoreRegion(countryCode) {
    countryCode = countryCode?.toUpperCase() || ''

    let storeRegion = 'UK'

    if (countryCode === 'US') {
      storeRegion = 'US'
    } else if (this.euRegionCodes.includes(countryCode)) {
      storeRegion = 'EU'
    }

    const option = this.els.optionsList.querySelector(
      `[data-store-region="${storeRegion}"]`,
    )
    if (option) {
      option.selected = true
    }

    return storeRegion
  }

  autoRedirectToStore(storeRegion) {
    const option = this.els.optionsList.querySelector(
      `[data-store-region="${storeRegion}"]`,
    )
    if (option && option.value) {
      this.setCookie(storeRegion)
      window.location.href = option.value
    }
  }

  redirectToStore() {
    const storeSwitcher = this.els.optionsList
    const selectedOption =
      storeSwitcher.selectedOptions && storeSwitcher.selectedOptions[0]
    if (!selectedOption) return

    const redirectUrl = selectedOption.value
    const storeRegion = selectedOption.dataset.storeRegion

    if (storeRegion === this.currentStoreRegion) {
      if (
        this.detectedRegion &&
        this.detectedRegion !== this.currentStoreRegion
      ) {
        this.hideDialog()
        return
      }
      this.setCookie(this.currentStoreRegion)
      return
    }

    if (this.detectedRegion && this.detectedRegion !== storeRegion) {
      window.location.href = redirectUrl
      return
    }

    this.setCookie(storeRegion)
    window.location.href = redirectUrl
  }

  checkCookie() {
    if (sessionStorage.getItem(this.sessionStorageKey) === 'true') {
      return true
    }

    const cookie = document.cookie
      .split('; ')
      .find((row) => row.startsWith(`${this.cookieName}=`))

    if (!cookie) {
      return false
    }

    this.cookieValue = cookie.split('=')[1]

    if (this.cookieValue === this.currentStoreRegion) {
      this.setCookie(this.cookieValue)
      return true
    } else {
      if (this.autoRedirect) {
        this.autoRedirectToStore(this.cookieValue)
        return true
      } else {
        this.showDialog()
      }
    }

    return false
  }

  setCookie(storeRegion) {
    document.cookie = `${this.cookieName}=${storeRegion}; path=/; max-age=${this.cookieExpiration}`
    this.hideDialog()
  }

  hideDialog() {
    this.els.dialog.removeAttribute('open')
  }

  showDialog() {
    this.els.dialog.setAttribute('open', '')
  }
}

if (!customElements.get('store-switcher')) {
  customElements.define('store-switcher', StoreSwitcher)
}
